import React, {useRef} from 'react';
import {Button, Col, Form, FormGroup, Modal, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faBank, faCheck, faPiggyBank} from "@fortawesome/free-solid-svg-icons";
import ApiService from "../../api/ApiService";
import {toast} from "react-toastify";

const CardInfoModal = ({visible, onClose}) => {
    const api = new ApiService();
    const [isMobile, setIsMobile] = React.useState(false);
    const [signInfo, setSignInfo] = React.useState(null);
    const [withdrawInfo, setWithdrawInfo] = React.useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(1); // 渠道，0,银行卡，1 支付宝，2 微信
    // 添加表单字段的状态
    const [realName, setRealName] = React.useState('');
    const [idNo, setIdNo] = React.useState('');
    const [account, setAccount] = React.useState('');
    const [mobile, setMobile] = React.useState('');
    const alipayIcon = '/images/vip/vip_pay_method_alipay.svg'

    React.useEffect(() => {
        if (!visible) {
            return;
        }
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);
        setSignInfo(null);
        setWithdrawInfo(null);
        setAccount(null);
        setMobile(null);
        getSignAccountInfo();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [visible]);
    const getSignAccountInfo = async () => {
        var result = await api.getUserSignInfo();
        if (result?.code !== 200) {
            toast.error(result?.msg)
        } else {
            if (result?.data?.sign) {
                setSignInfo(result?.data?.sign);
            }
            if (result?.data?.withdraw) {
                setWithdrawInfo(result?.data?.withdraw);
                // 使用 useEffect 监听 withdrawInfo 变化后再调用 setSelectedPayment
            }
        }
    };
    const submitInfo = async (event) => {

        event.preventDefault();
        if (!realName) {
            return toast.error('请填写真实姓名');
        }
        if (!idNo) {
            return toast.error('请填写身份证号');
        }
        const sign = await api.saveUserSignInfo(realName, idNo);
        if (sign?.code !== 200) {
            if (sign?.code === -1000){
                toast.error('输入正确的姓名和身份证号码');
            }else {
                toast.error(sign?.msg);
            }
        }

        if (!account) {
            return toast.error(selectedPaymentMethod === 1 ? '请填写支付宝账号' : '请填写银行卡账号');
        }
        if (!mobile) {
            return toast.error('请填写手机号码');
        }
        const withdraw = await api.saveUserWithdrawAccountInfo(account, mobile, selectedPaymentMethod);

        if (withdraw?.code !== 200) {
            toast.error(withdraw?.msg);
        }
        if (sign?.code === 200 && withdraw?.code === 200) {
            toast.success('信息保存成功')
            onClose(true);
        }
    };
    React.useEffect(() => {
        // 当 withdrawInfo 或 selectedPaymentMethod 变化时更新表单字段
        if (withdrawInfo && withdrawInfo.length > 0) {
            const selectedWithdrawInfo = withdrawInfo.find(item => item.channel === selectedPaymentMethod);
            if (selectedWithdrawInfo) {
                setAccount(selectedWithdrawInfo.account || '');
                setMobile(selectedWithdrawInfo.mobile || '');
            } else {
                setAccount('');
                setMobile('');
            }
        } else {
            setAccount('');
            setMobile('');
        }
        
        // 当 signInfo 变化时更新表单字段
        if (signInfo) {
            setRealName(signInfo.realName || '');
            setIdNo(signInfo.idNo || '');
        } else {
            setRealName('');
            setIdNo('');
        }
    }, [withdrawInfo, selectedPaymentMethod, signInfo]);
    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <span style={{color: '#060606', fontSize: '22px'}}>添加收款账号</span>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <h5 style={{color: '#FFFFFF'}}>用户信息<span style={{color: '#FF0000',fontSize: '14px',marginLeft: '20px'}}>注意！！请一定要填写以下真实资料，填错信息导致打款错误概不负责！！</span></h5>
                <Form onSubmit={submitInfo} style={{color: '#FFFFFF', fontSize: '14px'}}>
                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column xs={4} sm={2}>真实姓名</Form.Label>
                        <Col xs={8} sm={10}>
                            <Form.Control 
                                name={'realName'} 
                                placeholder='请输入真实姓名'
                                value={realName}
                                onChange={(e) => setRealName(e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column xs={4} sm={2}>身份证号</Form.Label>
                        <Col xs={8} sm={10}>
                            <Form.Control 
                                name={'idNo'} 
                                placeholder='请输入身份证号'
                                value={idNo}
                                onChange={(e) => setIdNo(e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                    <Row className="paymentMethod">
                        <Col md={6}>
                            <Button
                                type={"button"}
                                className={`w-100 mb-2 payment-method-button ${selectedPaymentMethod === 1 ? 'selected-payment-method-button' : ''}`}
                                onClick={() => setSelectedPaymentMethod(1)}>
                               <span style={{display: "inline-flex", alignItems: "center"}}>
                                     <img src={alipayIcon} alt="支付宝" className="payment-method-icon"/>
                                支付宝
                               </span>

                                <div className="payment-method-check">
                                    {selectedPaymentMethod === 1 &&
                                        <FontAwesomeIcon icon={faCheck} color={'#02C8E3'}/>}
                                </div>
                            </Button>
                        </Col>
                        <Col md={6}>
                            <Button
                                type={"button"}
                                className={`w-100 mb-2 payment-method-button ${selectedPaymentMethod === 0 ? 'selected-payment-method-button' : ''}`}
                                onClick={() => setSelectedPaymentMethod(0)}>
                                  <span style={{display: "inline-flex", alignItems: "center"}}><FontAwesomeIcon
                                      icon={faBank} className={'payment-method-icon'}/>
                                     银行卡
                                  </span>
                                <div className="payment-method-check">
                                    {selectedPaymentMethod === 0 &&
                                        <FontAwesomeIcon icon={faCheck} color={'#02C8E3'}/>}
                                </div>
                            </Button>
                        </Col>
                    </Row>
                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column xs={4}
                                    sm={2}>{selectedPaymentMethod === 1 ? '支付宝账号' : '银行卡账号'}</Form.Label>
                        <Col xs={8} sm={10}>
                            <Form.Control 
                                name={'account'}
                                placeholder={selectedPaymentMethod === 1 ? '请输入支付宝账号' : '请输入银行卡账号'}
                                value={account}
                                onChange={(e) => setAccount(e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column xs={4} sm={2}>手机号</Form.Label>
                        <Col xs={8} sm={10}>
                            <Form.Control 
                                placeholder='请输入手机号' 
                                name={'mobile'}
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                            />

                        </Col>
                    </FormGroup>
                    <Row style={{height: '50px'}}>
                        <Col xs={4} style={{textAlign: 'center'}}>
                            <Button variant="primary" type={'button'} onClick={() => onClose(false)} style={{
                                width: '100%',
                                height: '100%',
                                border: '1px solid #02C8E3',
                                background: "transparent",
                                color: '#02C8E3',
                            }}>
                                取消
                            </Button>
                        </Col>
                        <Col xs={8} style={{textAlign: 'center'}}>
                            <Button variant="primary" type={'submit'} style={{
                                width: '100%',
                                height: '100%',
                                background: 'linear-gradient(135deg,#02C8E3,#4B1E64 150%)',
                                border: 'none',
                                color: '#060606'
                            }}>
                                提交
                            </Button>
                        </Col>

                    </Row>
                </Form>
            </Modal.Body>
            {/* 全局CSS样式 */}
            <style>{`
                .form-control::placeholder {
                    color: #7D7D7D !important;
                }
            `}</style>
        </Modal>

    );
};

export default CardInfoModal;